export default function Node_Errors() {
  return <div>Node_Errors Component</div>;
}
